import { useState } from 'react';

import { Button, Space, Spin, Typography, message } from 'antd';

import apiConfig from '../../API_Utils/APIUtil/ApiConfig';
import CallApi from '../../API_Utils/APIUtil/CallApi';
import DocumentCard from '../../Components/Common/DocumentCard';
import { getError } from '../../clientUtils';

const Downloader = ({ onNext, jobResponse }) => {
  // fetch existing jobs

  const [jobrunning, setJobrunning] = useState(false);
  const [jobId, setJobId] = useState(null);
  const [jobStatus, setJobStatus] = useState(jobResponse);
  const [retry, setRetry] = useState(false);

  const pollStatus = (id) => {
    CallApi(
      { ...apiConfig.pollReorderJob, path: apiConfig.pollReorderJob.path(id) },
      undefined,
      undefined,
      setJobrunning,
      (res) => {
        if (['FAILED', 'CANCELLED'].includes(res.status)) {
          setJobId(null);
          setRetry(true);
          setJobStatus(res);
          return;
        }
        if (res.status !== 'COMPLETE') {
          pollStatus(id);
        } else {
          setJobId(null);
          setJobStatus(res);
        }
      },
      (res) => message.error(getError(res))
    );
  };

  const onFetch = () => {
    setJobStatus(null);
    setRetry(false);
    CallApi(
      apiConfig.triggerReorderDownloadJob,
      undefined,
      apiConfig.triggerReorderDownloadJob.body,
      setJobrunning,
      (res) => {
        setJobId(res?.job_id);
        pollStatus(res.job_id);
      },
      (res) => message.error(getError(res))
    );
  };

  return (
    <Space direction="vertical">
      <Typography.Title level={4}>Fetch Unicommerce Reorder Details</Typography.Title>
      <Button type="primary" onClick={onFetch} loading={jobrunning} disabled={!!jobId}>
        {retry ? 'Retry' : 'Fetch'}
      </Button>
      {retry ? <Typography.Text type="danger">{jobStatus?.error_message}</Typography.Text> : null}
      {jobId ? (
        <Space direction="vertical">
          <Typography.Text>Please wait while we are fetching your reorder file</Typography.Text>
          <Spin></Spin>
        </Space>
      ) : null}
      {jobStatus?.output_file_path ? (
        <Space direction="vertical">
          <Typography.Text>Please Download your file and upload in next step.</Typography.Text>
          <DocumentCard name="Reorder Details" link={jobStatus?.output_file_path} />
        </Space>
      ) : null}
      <Space className="btns-container">
        <Button onClick={() => onNext(jobStatus)} disabled={!jobStatus?.output_file_path}>
          Next
        </Button>
      </Space>
    </Space>
  );
};

export default Downloader;
